// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
  baseUrl: string;
};

export type LoginUserDto = {
  email: string;
  password: string;
};

export const Subject = {
  All: 'All',
  User: 'User',
  Organization: 'Organization',
  AuditEntry: 'AuditEntry',
  ParkingFacility: 'ParkingFacility',
  Station: 'Station',
  ParkAndRideFacility: 'ParkAndRideFacility',
} as const;

export type Subject = (typeof Subject)[keyof typeof Subject];

export const UserStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  INVITED: 'INVITED',
} as const;

export type UserStatus = (typeof UserStatus)[keyof typeof UserStatus];

export const UserRole = { ADMIN: 'ADMIN', USER: 'USER' } as const;

export type UserRole = (typeof UserRole)[keyof typeof UserRole];

export const OrganizationUserRole = { MANAGER: 'MANAGER', EDITOR: 'EDITOR' } as const;

export type OrganizationUserRole = (typeof OrganizationUserRole)[keyof typeof OrganizationUserRole];

export const OrganizationType = {
  MUNICIPAL: 'MUNICIPAL',
  PARKING_OPERATOR: 'PARKING_OPERATOR',
  THIRD_PARTY_SERVICE: 'THIRD_PARTY_SERVICE',
  OTHER: 'OTHER',
} as const;

export type OrganizationType = (typeof OrganizationType)[keyof typeof OrganizationType];

export const DataSource = {
  INTERNAL: 'INTERNAL',
  PARKING_FACILITY__FRANKFURT__PRISMA: 'PARKING_FACILITY__FRANKFURT__PRISMA',
  PARKING_FACILITY_DATA__FRANKFURT__PRISMA: 'PARKING_FACILITY_DATA__FRANKFURT__PRISMA',
  PARK_AND_RIDE_FACILITY_DATA__FRANKFURT__PARKING_PILOT: 'PARK_AND_RIDE_FACILITY_DATA__FRANKFURT__PARKING_PILOT',
} as const;

export type DataSource = (typeof DataSource)[keyof typeof DataSource];

export const TrafficSign = {
  P_314: 'P_314',
  PR: 'PR',
  NONE: 'NONE',
  OTHER: 'OTHER',
} as const;

export type TrafficSign = (typeof TrafficSign)[keyof typeof TrafficSign];

export const FacilityType = {
  SEPARATE_AREA: 'SEPARATE_AREA',
  ON_STREET_PARALLEL: 'ON_STREET_PARALLEL',
  ON_STREET_ANGLED: 'ON_STREET_ANGLED',
  CURB_NO_MARKING: 'CURB_NO_MARKING',
  MARKED_BAY_PARALLEL: 'MARKED_BAY_PARALLEL',
  PARKING_GARAGE: 'PARKING_GARAGE',
  PARKDECK: 'PARKDECK',
  OTHER: 'OTHER',
} as const;

export type FacilityType = (typeof FacilityType)[keyof typeof FacilityType];

export const TracingParkingSpace = {
  COUNTED: 'COUNTED',
  ESTIMATED: 'ESTIMATED',
  AUTOMATED: 'AUTOMATED',
} as const;

export type TracingParkingSpace = (typeof TracingParkingSpace)[keyof typeof TracingParkingSpace];

export const TracingCapacity = {
  COUNTED: 'COUNTED',
  ESTIMATED: 'ESTIMATED',
  AUTOMATED: 'AUTOMATED',
} as const;

export type TracingCapacity = (typeof TracingCapacity)[keyof typeof TracingCapacity];

export const CapacityClass = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  FULL: 'FULL',
} as const;

export type CapacityClass = (typeof CapacityClass)[keyof typeof CapacityClass];

export const ParkingSpaceMarking = {
  NOT_MARKED: 'NOT_MARKED',
  PARTIALLY_MARKED: 'PARTIALLY_MARKED',
  MARKED: 'MARKED',
} as const;

export type ParkingSpaceMarking = (typeof ParkingSpaceMarking)[keyof typeof ParkingSpaceMarking];

export const TypeOfManagement = {
  PARKING_METER: 'PARKING_METER',
  OTHER: 'OTHER',
  DB_SERVICE_COUNTER: 'DB_SERVICE_COUNTER',
  NO_ONSITE_PARKING_PERMIT: 'NO_ONSITE_PARKING_PERMIT',
  PARKING_TICKET_MACHINE: 'PARKING_TICKET_MACHINE',
} as const;

export type TypeOfManagement = (typeof TypeOfManagement)[keyof typeof TypeOfManagement];

export const EntranceProhibited = { LPG: 'LPG', CNG: 'CNG' } as const;

export type EntranceProhibited = (typeof EntranceProhibited)[keyof typeof EntranceProhibited];

export const ParkingSurface = {
  ASPHALT: 'ASPHALT',
  GRAVEL: 'GRAVEL',
  GRASS: 'GRASS',
} as const;

export type ParkingSurface = (typeof ParkingSurface)[keyof typeof ParkingSurface];

export type PointDto = {
  type: 'Point';
  coordinates: [number, number];
};

export type ParkingFacility = {
  __caslSubjectType__: Subject;
  dataSource: DataSource;
  trafficSign: TrafficSign | null;
  facilityType: FacilityType | null;
  numParkingSpaceTotal: number | null;
  tracingParkingSpace: TracingParkingSpace | null;
  tracingCapacity: TracingCapacity | null;
  capacityClass: CapacityClass | null;
  numParkingSpaceDisabled: number | null;
  numParkingSpaceWomen: number | null;
  numParkingSpaceMotorcycle: number | null;
  parkingSpaceMarking: ParkingSpaceMarking | null;
  typeOfManagement: TypeOfManagement | null;
  entranceProhibited: Array<EntranceProhibited> | null;
  parkingSurface: ParkingSurface | null;
  deletedAt: string;
  externalId: string;
  organizationId: string | null;
  organization?: Organization;
  name: string;
  geometry: PointDto | null;
  entranceStreet: string | null;
  entranceHouseNumber: string | null;
  entranceSecondaryStreet: string | null;
  entranceSecondaryHouseNumber: string | null;
  postalCode: string | null;
  city: string | null;
  trafficSignAdditional: string | null;
  parkingSpaceLastUpdate: string | null;
  capacityPercentage: number | null;
  capacityDate: string | null;
  lighting: boolean | null;
  entranceHeight: number | null;
  entranceWidth: number | null;
  isAlwaysOpen: boolean;
  openingHours: string | null;
  freeToUse: boolean;
  managementUrl: string | null;
  isParkingUnlimited: boolean;
  parkingDuration: string | null;
  usable: boolean | null;
  publication: boolean;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export const UsageExtent = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  UNCLEAR: 'UNCLEAR',
} as const;

export type UsageExtent = (typeof UsageExtent)[keyof typeof UsageExtent];

export const StationType = { TRAIN: 'TRAIN', BUS: 'BUS' } as const;

export type StationType = (typeof StationType)[keyof typeof StationType];

export type Station = {
  __caslSubjectType__: Subject;
  rmvNumber: number | null;
  type: StationType;
  numBrFacility: number | null;
  numBikeParkingStation: number | null;
  numBikeParkingCovered: number | null;
  numBikeReadyToRide: number | null;
  deletedAt: string;
  rmvId: string;
  name: string;
  parkAndRideFacilities?: Array<ParkAndRideFacility>;
  stationComment: string | null;
  geometry: PointDto | null;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type ParkAndRideFacility = {
  __caslSubjectType__: Subject;
  dataSource: DataSource;
  trafficSign: TrafficSign | null;
  facilityType: FacilityType | null;
  numParkingSpaceTotal: number | null;
  tracingParkingSpace: TracingParkingSpace | null;
  tracingCapacity: TracingCapacity | null;
  capacityClass: CapacityClass | null;
  numParkingSpaceDisabled: number | null;
  numParkingSpaceWomen: number | null;
  numParkingSpaceMotorcycle: number | null;
  parkingSpaceMarking: ParkingSpaceMarking | null;
  typeOfManagement: TypeOfManagement | null;
  entranceProhibited: Array<EntranceProhibited> | null;
  parkingSurface: ParkingSurface | null;
  usageExtent: UsageExtent | null;
  stationId: string | null;
  station?: Station;
  prOfficial: boolean | null;
  prUsageComment: string | null;
  toStationAccessibility: boolean | null;
  prStatusNote: string | null;
  legacyId: string | null;
  rmvId: string | null;
  deletedAt: string;
  externalId: string;
  organizationId: string | null;
  organization?: Organization;
  name: string;
  geometry: PointDto | null;
  entranceStreet: string | null;
  entranceHouseNumber: string | null;
  entranceSecondaryStreet: string | null;
  entranceSecondaryHouseNumber: string | null;
  postalCode: string | null;
  city: string | null;
  trafficSignAdditional: string | null;
  parkingSpaceLastUpdate: string | null;
  capacityPercentage: number | null;
  capacityDate: string | null;
  lighting: boolean | null;
  entranceHeight: number | null;
  entranceWidth: number | null;
  isAlwaysOpen: boolean;
  openingHours: string | null;
  freeToUse: boolean;
  managementUrl: string | null;
  isParkingUnlimited: boolean;
  parkingDuration: string | null;
  usable: boolean | null;
  publication: boolean;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type Organization = {
  __caslSubjectType__: Subject;
  organizationType: OrganizationType | null;
  name: string;
  users?: Array<OrganizationUser>;
  parkingFacilities?: Array<ParkingFacility>;
  parkAndRideFacilities?: Array<ParkAndRideFacility>;
  contact: string | null;
  url: string | null;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type Invitation = {
  __caslSubjectType__: Subject;
  validityDays: number;
  user?: User;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export const AuditModel = {
  ParkingFacility: 'ParkingFacility',
  Station: 'Station',
  ParkAndRideFacility: 'ParkAndRideFacility',
} as const;

export type AuditModel = (typeof AuditModel)[keyof typeof AuditModel];

export const AuditAction = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
} as const;

export type AuditAction = (typeof AuditAction)[keyof typeof AuditAction];

export type AuditEntry = {
  __caslSubjectType__: Subject;
  model: AuditModel;
  action: AuditAction;
  id: string;
  createdAt: string;
  user?: User | null;
  data: {
    [key: string]: unknown;
  };
};

export type User = {
  __caslSubjectType__: Subject;
  status: UserStatus;
  role: UserRole;
  firstName: string | null;
  lastName: string | null;
  email: string;
  organization?: OrganizationUser | null;
  invitation?: Invitation | null;
  auditEntries?: Array<AuditEntry>;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type OrganizationUser = {
  __caslSubjectType__: Subject;
  role: OrganizationUserRole;
  organizationId: string;
  organization?: Organization;
  userId: string;
  user?: User;
  createdAt: string;
  updatedAt: string;
};

export const JwtTokenType = { ACCESS: 'ACCESS', REFRESH: 'REFRESH' } as const;

export type JwtTokenType = (typeof JwtTokenType)[keyof typeof JwtTokenType];

export type RefreshTokenDto = {
  type: JwtTokenType;
};

export type InitializePasswordResetDto = {
  email: string;
};

export type SubmitPasswordResetDto = {
  password: string;
};

export type CreateUserDto = {
  role: UserRole;
  organizationUserRole?: OrganizationUserRole;
  email: string;
  organizationId?: string;
};

export type UpdateUserDto = {
  role?: UserRole;
  organizationUserRole?: OrganizationUserRole;
  email?: string;
  organizationId?: string;
  status?: UserStatus;
  firstName?: string;
  lastName?: string;
  password?: string;
};

export const Action = {
  MANAGE: 'MANAGE',
  CREATE: 'CREATE',
  READ: 'READ',
  READ_ALL: 'READ_ALL',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
} as const;

export type Action = (typeof Action)[keyof typeof Action];

export type CaslEnumDto = {
  action: Action;
  subject: Subject;
};

export type CaslRulesDto = {
  rules: Array<
    Array<
      | Action
      | Subject
      | string
      | number
      | {
          [key: string]: unknown;
        }
    >
  >;
};

export type AcceptInvitationDto = {
  firstName: string;
  lastName: string;
  password: string;
};

export type CreateOrganizationDto = {
  name: string;
  contact?: string | null;
  url?: string | null;
  organizationType: 'MUNICIPAL' | 'PARKING_OPERATOR' | 'THIRD_PARTY_SERVICE' | 'OTHER';
};

export type UpdateOrganizationDto = {
  name?: string;
  contact?: string | null;
  url?: string | null;
  organizationType?: OrganizationType;
};

export type CreateOrganizationUserDto = {
  role: OrganizationUserRole;
  email: string;
};

export type UpdateOrganizationUserDto = {
  role?: OrganizationUserRole;
};

export type CreateParkingFacilityDto = {
  name: string;
  organizationId: string;
};

export type UpdateParkingFacilityDto = {
  name?: string;
  organizationId?: string;
  parkingSpaceLastUpdate?: string | null;
  trafficSign?: TrafficSign | null;
  facilityType?: FacilityType | null;
  capacityDate?: string | null;
  entranceProhibited?: Array<EntranceProhibited> | null;
  usable?: boolean;
  geometry?: PointDto;
  entranceStreet?: string;
  entranceHouseNumber?: string;
  entranceSecondaryStreet?: string;
  entranceSecondaryHouseNumber?: string;
  postalCode?: string;
  city?: string;
  prOfficial?: boolean;
  numParkingSpaceTotal?: number;
  numParkingSpaceDisabled?: number | null;
  numParkingSpaceWomen?: number | null;
  numParkingSpaceMotorcycle?: number | null;
  tracingParkingSpace?: 'COUNTED' | 'ESTIMATED' | 'AUTOMATED';
  capacityClass?: 'LOW' | 'MEDIUM' | 'HIGH' | 'FULL';
  capacityPercentage?: number;
  trafficSignAdditional?: string | null;
  tracingCapacity?: 'COUNTED' | 'ESTIMATED' | 'AUTOMATED';
  prUsageComment?: string | null;
  usageExtent?: 'LOW' | 'MEDIUM' | 'HIGH' | 'UNCLEAR';
  parkingSpaceMarking?: 'NOT_MARKED' | 'PARTIALLY_MARKED' | 'MARKED';
  lighting?: boolean;
  typeOfManagement?:
    | 'PARKING_METER'
    | 'OTHER'
    | 'DB_SERVICE_COUNTER'
    | 'NO_ONSITE_PARKING_PERMIT'
    | 'PARKING_TICKET_MACHINE';
  entranceHeight?: number | null;
  entranceWidth?: number | null;
  isAlwaysOpen?: boolean;
  openingHours?: string | null;
  freeToUse?: boolean;
  managementUrl?: string | null;
  isParkingUnlimited?: boolean;
  parkingDuration?: string | null;
  prStatusNote?: string | null;
  parkingSurface?: 'ASPHALT' | 'GRAVEL' | 'GRASS';
  publication?: boolean;
};

export type CreateStationDto = {
  type: StationType;
  name: string;
  rmvId: string;
  rmvNumber: number;
  geometry: PointDto;
};

export type UpdateStationDto = {
  type?: StationType;
  name?: string;
  rmvId?: string;
  rmvNumber?: number;
  geometry?: PointDto;
  stationComment?: string | null;
  numBrFacility?: number | null;
  numBikeParkingStation?: number | null;
  numBikeParkingCovered?: number | null;
  numBikeReadyToRide?: number | null;
};

export type CreateParkAndRideFacilityDto = {
  name: string;
  organizationId: string;
  stationId?: string;
  rmvId?: string;
};

export type UpdateParkAndRideFacilityDto = {
  name?: string;
  organizationId?: string;
  stationId?: string;
  rmvId?: string;
  parkingSpaceLastUpdate?: string | null;
  trafficSign?: TrafficSign | null;
  facilityType?: FacilityType | null;
  capacityDate?: string | null;
  entranceProhibited?: Array<EntranceProhibited> | null;
  usable?: boolean;
  geometry?: PointDto;
  entranceStreet?: string;
  entranceHouseNumber?: string;
  entranceSecondaryStreet?: string;
  entranceSecondaryHouseNumber?: string;
  postalCode?: string;
  city?: string;
  prOfficial?: boolean;
  numParkingSpaceTotal?: number;
  numParkingSpaceDisabled?: number | null;
  numParkingSpaceWomen?: number | null;
  numParkingSpaceMotorcycle?: number | null;
  tracingParkingSpace?: 'COUNTED' | 'ESTIMATED' | 'AUTOMATED';
  capacityClass?: 'LOW' | 'MEDIUM' | 'HIGH' | 'FULL';
  capacityPercentage?: number;
  trafficSignAdditional?: string | null;
  tracingCapacity?: 'COUNTED' | 'ESTIMATED' | 'AUTOMATED';
  prUsageComment?: string | null;
  usageExtent?: 'LOW' | 'MEDIUM' | 'HIGH' | 'UNCLEAR';
  parkingSpaceMarking?: 'NOT_MARKED' | 'PARTIALLY_MARKED' | 'MARKED';
  lighting?: boolean;
  toStationAccessibility?: boolean;
  typeOfManagement?:
    | 'PARKING_METER'
    | 'OTHER'
    | 'DB_SERVICE_COUNTER'
    | 'NO_ONSITE_PARKING_PERMIT'
    | 'PARKING_TICKET_MACHINE';
  entranceHeight?: number | null;
  entranceWidth?: number | null;
  isAlwaysOpen?: boolean;
  openingHours?: string | null;
  freeToUse?: boolean;
  managementUrl?: string | null;
  isParkingUnlimited?: boolean;
  parkingDuration?: string | null;
  prStatusNote?: string | null;
  parkingSurface?: 'ASPHALT' | 'GRAVEL' | 'GRASS';
  publication?: boolean;
};

export type CreateContactRequestDto = {
  salutation: string;
  firstName: string;
  lastName: string;
  email: string;
  location?: string;
  message: string;
};

export type ParkingFacilityData = {
  dataSource: DataSource;
  numVacantSpaces: number | null;
  facility: ParkingFacility;
  id: string;
  timestamp: string;
  occupancyPercent: number;
};

export type ParkAndRideFacilityData = {
  dataSource: DataSource;
  numVacantSpaces: number | null;
  facility: ParkAndRideFacility;
  id: string;
  timestamp: string;
  occupancyPercent: number;
};

export type HealthCheckData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/health';
};

export type HealthCheckErrors = {
  /**
   * The Health Check is not successful
   */
  503: {
    status?: string;
    info?: {
      [key: string]: {
        status: string;
        [key: string]: unknown;
      };
    } | null;
    error?: {
      [key: string]: {
        status: string;
        [key: string]: unknown;
      };
    } | null;
    details?: {
      [key: string]: {
        status: string;
        [key: string]: unknown;
      };
    };
  };
};

export type HealthCheckError = HealthCheckErrors[keyof HealthCheckErrors];

export type HealthCheckResponses = {
  /**
   * The Health Check is successful
   */
  200: {
    status?: string;
    info?: {
      [key: string]: {
        status: string;
        [key: string]: unknown;
      };
    } | null;
    error?: {
      [key: string]: {
        status: string;
        [key: string]: unknown;
      };
    } | null;
    details?: {
      [key: string]: {
        status: string;
        [key: string]: unknown;
      };
    };
  };
};

export type HealthCheckResponse = HealthCheckResponses[keyof HealthCheckResponses];

export type AuthenticationLogoutData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/authentication';
};

export type AuthenticationLogoutResponses = {
  204: void;
};

export type AuthenticationLogoutResponse = AuthenticationLogoutResponses[keyof AuthenticationLogoutResponses];

export type AuthenticationGetUserData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/authentication';
};

export type AuthenticationGetUserResponses = {
  200: User;
};

export type AuthenticationGetUserResponse = AuthenticationGetUserResponses[keyof AuthenticationGetUserResponses];

export type AuthenticationLoginData = {
  body: LoginUserDto;
  path?: never;
  query?: never;
  url: '/api/authentication';
};

export type AuthenticationLoginResponses = {
  201: User;
};

export type AuthenticationLoginResponse = AuthenticationLoginResponses[keyof AuthenticationLoginResponses];

export type AuthenticationRefreshData = {
  body: RefreshTokenDto;
  path?: never;
  query?: never;
  url: '/api/authentication/refresh';
};

export type AuthenticationRefreshResponses = {
  201: unknown;
};

export type PasswordResetInitializeData = {
  body: InitializePasswordResetDto;
  path?: never;
  query?: never;
  url: '/api/password-reset';
};

export type PasswordResetInitializeResponses = {
  201: unknown;
};

export type PasswordResetSubmitData = {
  body: SubmitPasswordResetDto;
  path: {
    authenticationTokenId: string;
  };
  query: {
    token: string;
  };
  url: '/api/password-reset/{authenticationTokenId}';
};

export type PasswordResetSubmitResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type PasswordResetSubmitResponse = PasswordResetSubmitResponses[keyof PasswordResetSubmitResponses];

export type UsersFindAllData = {
  body?: never;
  path?: never;
  query?: {
    role?: Array<UserRole>;
    status?: Array<UserStatus>;
    search?: string;
  };
  url: '/api/users';
};

export type UsersFindAllResponses = {
  200: Array<User>;
};

export type UsersFindAllResponse = UsersFindAllResponses[keyof UsersFindAllResponses];

export type UsersCreateData = {
  body: CreateUserDto;
  path?: never;
  query?: never;
  url: '/api/users';
};

export type UsersCreateResponses = {
  201: User;
};

export type UsersCreateResponse = UsersCreateResponses[keyof UsersCreateResponses];

export type UsersRemoveData = {
  body?: never;
  path: {
    userId: string;
  };
  query?: never;
  url: '/api/users/{userId}';
};

export type UsersRemoveResponses = {
  200: User;
};

export type UsersRemoveResponse = UsersRemoveResponses[keyof UsersRemoveResponses];

export type UsersFindOneData = {
  body?: never;
  path: {
    userId: string;
  };
  query?: never;
  url: '/api/users/{userId}';
};

export type UsersFindOneResponses = {
  200: User;
};

export type UsersFindOneResponse = UsersFindOneResponses[keyof UsersFindOneResponses];

export type UsersUpdateData = {
  body: UpdateUserDto;
  path: {
    userId: string;
  };
  query?: never;
  url: '/api/users/{userId}';
};

export type UsersUpdateResponses = {
  200: User;
};

export type UsersUpdateResponse = UsersUpdateResponses[keyof UsersUpdateResponses];

export type CaslGetRulesData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/casl';
};

export type CaslGetRulesResponses = {
  200: CaslRulesDto;
};

export type CaslGetRulesResponse = CaslGetRulesResponses[keyof CaslGetRulesResponses];

export type InvitationsReinviteData = {
  body?: never;
  path: {
    userId: string;
  };
  query?: never;
  url: '/api/invitations/{userId}';
};

export type InvitationsReinviteResponses = {
  201: User;
};

export type InvitationsReinviteResponse = InvitationsReinviteResponses[keyof InvitationsReinviteResponses];

export type InvitationsAcceptData = {
  body: AcceptInvitationDto;
  path: {
    authenticationTokenId: string;
  };
  query: {
    token: string;
  };
  url: '/api/invitations/{authenticationTokenId}';
};

export type InvitationsAcceptResponses = {
  200: {
    [key: string]: unknown;
  };
};

export type InvitationsAcceptResponse = InvitationsAcceptResponses[keyof InvitationsAcceptResponses];

export type OrganizationsFindAllData = {
  body?: never;
  path?: never;
  query?: {
    search?: string;
  };
  url: '/api/organizations';
};

export type OrganizationsFindAllResponses = {
  200: Array<Organization>;
};

export type OrganizationsFindAllResponse = OrganizationsFindAllResponses[keyof OrganizationsFindAllResponses];

export type OrganizationsCreateData = {
  body: CreateOrganizationDto;
  path?: never;
  query?: never;
  url: '/api/organizations';
};

export type OrganizationsCreateResponses = {
  201: Organization;
};

export type OrganizationsCreateResponse = OrganizationsCreateResponses[keyof OrganizationsCreateResponses];

export type OrganizationsRemoveData = {
  body?: never;
  path: {
    organizationId: string;
  };
  query?: never;
  url: '/api/organizations/{organizationId}';
};

export type OrganizationsRemoveResponses = {
  200: Organization;
};

export type OrganizationsRemoveResponse = OrganizationsRemoveResponses[keyof OrganizationsRemoveResponses];

export type OrganizationsFindOneData = {
  body?: never;
  path: {
    organizationId: string;
  };
  query?: {
    users?: boolean;
  };
  url: '/api/organizations/{organizationId}';
};

export type OrganizationsFindOneResponses = {
  200: Organization;
};

export type OrganizationsFindOneResponse = OrganizationsFindOneResponses[keyof OrganizationsFindOneResponses];

export type OrganizationsUpdateData = {
  body: UpdateOrganizationDto;
  path: {
    organizationId: string;
  };
  query?: never;
  url: '/api/organizations/{organizationId}';
};

export type OrganizationsUpdateResponses = {
  200: Organization;
};

export type OrganizationsUpdateResponse = OrganizationsUpdateResponses[keyof OrganizationsUpdateResponses];

export type OrganizationsCreateOrganizationUserData = {
  body: CreateOrganizationUserDto;
  path: {
    organizationId: string;
  };
  query?: never;
  url: '/api/organizations/{organizationId}/users';
};

export type OrganizationsCreateOrganizationUserResponses = {
  201: OrganizationUser;
};

export type OrganizationsCreateOrganizationUserResponse =
  OrganizationsCreateOrganizationUserResponses[keyof OrganizationsCreateOrganizationUserResponses];

export type OrganizationsRemoveOrganizationUserData = {
  body?: never;
  path: {
    organizationId: string;
    userId: string;
  };
  query?: never;
  url: '/api/organizations/{organizationId}/users/{userId}';
};

export type OrganizationsRemoveOrganizationUserResponses = {
  200: OrganizationUser;
};

export type OrganizationsRemoveOrganizationUserResponse =
  OrganizationsRemoveOrganizationUserResponses[keyof OrganizationsRemoveOrganizationUserResponses];

export type OrganizationsFindOneOrganizationUserData = {
  body?: never;
  path: {
    organizationId: string;
    userId: string;
  };
  query?: never;
  url: '/api/organizations/{organizationId}/users/{userId}';
};

export type OrganizationsFindOneOrganizationUserResponses = {
  200: OrganizationUser;
};

export type OrganizationsFindOneOrganizationUserResponse =
  OrganizationsFindOneOrganizationUserResponses[keyof OrganizationsFindOneOrganizationUserResponses];

export type OrganizationsUpdateOrganizationUserData = {
  body: UpdateOrganizationUserDto;
  path: {
    organizationId: string;
    userId: string;
  };
  query?: never;
  url: '/api/organizations/{organizationId}/users/{userId}';
};

export type OrganizationsUpdateOrganizationUserResponses = {
  200: OrganizationUser;
};

export type OrganizationsUpdateOrganizationUserResponse =
  OrganizationsUpdateOrganizationUserResponses[keyof OrganizationsUpdateOrganizationUserResponses];

export type ParkingFacilitiesFindAllData = {
  body?: never;
  path?: never;
  query?: {
    search?: string;
    organizationId?: string;
    publication?: boolean;
  };
  url: '/api/parking-facilities';
};

export type ParkingFacilitiesFindAllResponses = {
  200: Array<ParkingFacility>;
};

export type ParkingFacilitiesFindAllResponse =
  ParkingFacilitiesFindAllResponses[keyof ParkingFacilitiesFindAllResponses];

export type ParkingFacilitiesCreateData = {
  body: CreateParkingFacilityDto;
  path?: never;
  query?: never;
  url: '/api/parking-facilities';
};

export type ParkingFacilitiesCreateResponses = {
  201: ParkingFacility;
};

export type ParkingFacilitiesCreateResponse = ParkingFacilitiesCreateResponses[keyof ParkingFacilitiesCreateResponses];

export type ParkingFacilitiesExportCsvData = {
  body?: never;
  path?: never;
  query?: {
    search?: string;
    organizationId?: string;
    publication?: boolean;
  };
  url: '/api/parking-facilities/export.csv';
};

export type ParkingFacilitiesExportCsvResponses = {
  200: unknown;
};

export type ParkingFacilitiesRemoveData = {
  body?: never;
  path: {
    parkingFacilityId: string;
  };
  query?: never;
  url: '/api/parking-facilities/{parkingFacilityId}';
};

export type ParkingFacilitiesRemoveResponses = {
  200: ParkingFacility;
};

export type ParkingFacilitiesRemoveResponse = ParkingFacilitiesRemoveResponses[keyof ParkingFacilitiesRemoveResponses];

export type ParkingFacilitiesFindOneData = {
  body?: never;
  path: {
    parkingFacilityId: string;
  };
  query?: {
    organization?: boolean;
  };
  url: '/api/parking-facilities/{parkingFacilityId}';
};

export type ParkingFacilitiesFindOneResponses = {
  200: ParkingFacility;
};

export type ParkingFacilitiesFindOneResponse =
  ParkingFacilitiesFindOneResponses[keyof ParkingFacilitiesFindOneResponses];

export type ParkingFacilitiesUpdateData = {
  body: UpdateParkingFacilityDto;
  path: {
    parkingFacilityId: string;
  };
  query?: never;
  url: '/api/parking-facilities/{parkingFacilityId}';
};

export type ParkingFacilitiesUpdateResponses = {
  200: ParkingFacility;
};

export type ParkingFacilitiesUpdateResponse = ParkingFacilitiesUpdateResponses[keyof ParkingFacilitiesUpdateResponses];

export type ParkingFacilitiesFindAllAuditsData = {
  body?: never;
  path: {
    parkingFacilityId: string;
  };
  query?: never;
  url: '/api/parking-facilities/{parkingFacilityId}/audits';
};

export type ParkingFacilitiesFindAllAuditsResponses = {
  200: Array<AuditEntry>;
};

export type ParkingFacilitiesFindAllAuditsResponse =
  ParkingFacilitiesFindAllAuditsResponses[keyof ParkingFacilitiesFindAllAuditsResponses];

export type ParkingFacilitiesFindOneAuditData = {
  body?: never;
  path: {
    parkingFacilityId: string;
    auditCreatedAt: string;
  };
  query?: never;
  url: '/api/parking-facilities/{parkingFacilityId}/audits/{auditCreatedAt}';
};

export type ParkingFacilitiesFindOneAuditResponses = {
  200: AuditEntry;
};

export type ParkingFacilitiesFindOneAuditResponse =
  ParkingFacilitiesFindOneAuditResponses[keyof ParkingFacilitiesFindOneAuditResponses];

export type StationsFindAllData = {
  body?: never;
  path?: never;
  query?: {
    search?: string;
    organizationIds?: Array<string>;
    parkAndRideFacilitiesPublication?: boolean;
  };
  url: '/api/stations';
};

export type StationsFindAllResponses = {
  200: Array<Station>;
};

export type StationsFindAllResponse = StationsFindAllResponses[keyof StationsFindAllResponses];

export type StationsCreateData = {
  body: CreateStationDto;
  path?: never;
  query?: never;
  url: '/api/stations';
};

export type StationsCreateResponses = {
  201: Station;
};

export type StationsCreateResponse = StationsCreateResponses[keyof StationsCreateResponses];

export type StationsRemoveData = {
  body?: never;
  path: {
    stationId: string;
  };
  query?: never;
  url: '/api/stations/{stationId}';
};

export type StationsRemoveResponses = {
  200: Station;
};

export type StationsRemoveResponse = StationsRemoveResponses[keyof StationsRemoveResponses];

export type StationsFindOneData = {
  body?: never;
  path: {
    stationId: string;
  };
  query?: {
    parkAndRideFacilities?: boolean;
    parkAndRideFacilitiesPublication?: boolean;
  };
  url: '/api/stations/{stationId}';
};

export type StationsFindOneResponses = {
  200: Station;
};

export type StationsFindOneResponse = StationsFindOneResponses[keyof StationsFindOneResponses];

export type StationsUpdateData = {
  body: UpdateStationDto;
  path: {
    stationId: string;
  };
  query?: never;
  url: '/api/stations/{stationId}';
};

export type StationsUpdateResponses = {
  200: Station;
};

export type StationsUpdateResponse = StationsUpdateResponses[keyof StationsUpdateResponses];

export type StationsFindAllAuditsData = {
  body?: never;
  path: {
    stationId: string;
  };
  query?: never;
  url: '/api/stations/{stationId}/audits';
};

export type StationsFindAllAuditsResponses = {
  200: Array<AuditEntry>;
};

export type StationsFindAllAuditsResponse = StationsFindAllAuditsResponses[keyof StationsFindAllAuditsResponses];

export type StationsFindOneAuditData = {
  body?: never;
  path: {
    stationId: string;
    auditCreatedAt: string;
  };
  query?: never;
  url: '/api/stations/{stationId}/audits/{auditCreatedAt}';
};

export type StationsFindOneAuditResponses = {
  200: AuditEntry;
};

export type StationsFindOneAuditResponse = StationsFindOneAuditResponses[keyof StationsFindOneAuditResponses];

export type ParkAndRideFacilitiesFindAllData = {
  body?: never;
  path?: never;
  query?: {
    search?: string;
    stationId?: string;
    organizationId?: string;
    publication?: boolean;
    stationless?: boolean;
  };
  url: '/api/park-and-ride-facilities';
};

export type ParkAndRideFacilitiesFindAllResponses = {
  200: Array<ParkAndRideFacility>;
};

export type ParkAndRideFacilitiesFindAllResponse =
  ParkAndRideFacilitiesFindAllResponses[keyof ParkAndRideFacilitiesFindAllResponses];

export type ParkAndRideFacilitiesCreateData = {
  body: CreateParkAndRideFacilityDto;
  path?: never;
  query?: never;
  url: '/api/park-and-ride-facilities';
};

export type ParkAndRideFacilitiesCreateResponses = {
  201: ParkAndRideFacility;
};

export type ParkAndRideFacilitiesCreateResponse =
  ParkAndRideFacilitiesCreateResponses[keyof ParkAndRideFacilitiesCreateResponses];

export type ParkAndRideFacilitiesExportCsvData = {
  body?: never;
  path?: never;
  query?: {
    search?: string;
    stationId?: string;
    organizationId?: string;
    publication?: boolean;
    stationless?: boolean;
  };
  url: '/api/park-and-ride-facilities/export.csv';
};

export type ParkAndRideFacilitiesExportCsvResponses = {
  200: unknown;
};

export type ParkAndRideFacilitiesRemoveData = {
  body?: never;
  path: {
    parkAndRideFacilityId: string;
  };
  query?: never;
  url: '/api/park-and-ride-facilities/{parkAndRideFacilityId}';
};

export type ParkAndRideFacilitiesRemoveResponses = {
  200: ParkAndRideFacility;
};

export type ParkAndRideFacilitiesRemoveResponse =
  ParkAndRideFacilitiesRemoveResponses[keyof ParkAndRideFacilitiesRemoveResponses];

export type ParkAndRideFacilitiesFindOneData = {
  body?: never;
  path: {
    parkAndRideFacilityId: string;
  };
  query?: {
    station?: boolean;
    organization?: boolean;
  };
  url: '/api/park-and-ride-facilities/{parkAndRideFacilityId}';
};

export type ParkAndRideFacilitiesFindOneResponses = {
  200: ParkAndRideFacility;
};

export type ParkAndRideFacilitiesFindOneResponse =
  ParkAndRideFacilitiesFindOneResponses[keyof ParkAndRideFacilitiesFindOneResponses];

export type ParkAndRideFacilitiesUpdateData = {
  body: UpdateParkAndRideFacilityDto;
  path: {
    parkAndRideFacilityId: string;
  };
  query?: never;
  url: '/api/park-and-ride-facilities/{parkAndRideFacilityId}';
};

export type ParkAndRideFacilitiesUpdateResponses = {
  200: ParkAndRideFacility;
};

export type ParkAndRideFacilitiesUpdateResponse =
  ParkAndRideFacilitiesUpdateResponses[keyof ParkAndRideFacilitiesUpdateResponses];

export type ParkAndRideFacilitiesFindAllAuditsData = {
  body?: never;
  path: {
    parkAndRideFacilityId: string;
  };
  query?: never;
  url: '/api/park-and-ride-facilities/{parkAndRideFacilityId}/audits';
};

export type ParkAndRideFacilitiesFindAllAuditsResponses = {
  200: Array<AuditEntry>;
};

export type ParkAndRideFacilitiesFindAllAuditsResponse =
  ParkAndRideFacilitiesFindAllAuditsResponses[keyof ParkAndRideFacilitiesFindAllAuditsResponses];

export type ParkAndRideFacilitiesFindOneAuditData = {
  body?: never;
  path: {
    parkAndRideFacilityId: string;
    auditCreatedAt: string;
  };
  query?: never;
  url: '/api/park-and-ride-facilities/{parkAndRideFacilityId}/audits/{auditCreatedAt}';
};

export type ParkAndRideFacilitiesFindOneAuditResponses = {
  200: AuditEntry;
};

export type ParkAndRideFacilitiesFindOneAuditResponse =
  ParkAndRideFacilitiesFindOneAuditResponses[keyof ParkAndRideFacilitiesFindOneAuditResponses];

export type ContactRequestsCreateData = {
  body: CreateContactRequestDto;
  path?: never;
  query?: never;
  url: '/api/contact-requests';
};

export type ContactRequestsCreateResponses = {
  201: unknown;
};

export type ParkingDataFindAllLatestParkingFacilityDataData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/parking-data/parking-facility/latest';
};

export type ParkingDataFindAllLatestParkingFacilityDataResponses = {
  200: Array<ParkingFacilityData>;
};

export type ParkingDataFindAllLatestParkingFacilityDataResponse =
  ParkingDataFindAllLatestParkingFacilityDataResponses[keyof ParkingDataFindAllLatestParkingFacilityDataResponses];

export type ParkingDataFindAllParkingFacilityDataData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/parking-data/parking-facility';
};

export type ParkingDataFindAllParkingFacilityDataResponses = {
  200: Array<ParkingFacilityData>;
};

export type ParkingDataFindAllParkingFacilityDataResponse =
  ParkingDataFindAllParkingFacilityDataResponses[keyof ParkingDataFindAllParkingFacilityDataResponses];

export type ParkingDataFindAllLatestParkAndRideFacilityDataData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/parking-data/park-and-ride-facility/latest';
};

export type ParkingDataFindAllLatestParkAndRideFacilityDataResponses = {
  200: Array<ParkAndRideFacilityData>;
};

export type ParkingDataFindAllLatestParkAndRideFacilityDataResponse =
  ParkingDataFindAllLatestParkAndRideFacilityDataResponses[keyof ParkingDataFindAllLatestParkAndRideFacilityDataResponses];

export type ParkingDataFindAllParkAndRideFacilityDataData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/parking-data/park-and-ride-facility';
};

export type ParkingDataFindAllParkAndRideFacilityDataResponses = {
  200: Array<ParkAndRideFacilityData>;
};

export type ParkingDataFindAllParkAndRideFacilityDataResponse =
  ParkingDataFindAllParkAndRideFacilityDataResponses[keyof ParkingDataFindAllParkAndRideFacilityDataResponses];
